import { render, staticRenderFns } from "./PerformerSources.vue?vue&type=template&id=7f5a181e&"
import script from "./PerformerSources.vue?vue&type=script&lang=js&"
export * from "./PerformerSources.vue?vue&type=script&lang=js&"
import style0 from "./PerformerSources.vue?vue&type=style&index=0&id=7f5a181e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports